import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from '../../store'

import type { SignUpSliceState } from './SignUp.slice'

export const selectSignUp = (state: RootState) => state.signUp

export const selectCredentials = createSelector(
  selectSignUp,
  (signUpState: SignUpSliceState) => signUpState.userAuth,
)

export const selectOnboardingRequest = createSelector(
  selectSignUp,
  (signUpState: SignUpSliceState) => ({
    email: signUpState.userAuth.email,
    phoneNumber: signUpState.userAuth.phoneNumber,
    authToken: signUpState.userAuth.authToken,
  }),
)
